import React from 'react';

import { useGetFundFromOrigin } from '@api/funds/api.funds.queries';
import { useAuth } from '@components/utilComponents/AuthProvider';

import {
  carrotQuestAuth,
  carrotQuestIdentifyUser,
  setUpMetricaGoals,
  setUpTrackingEvents,
} from './helpers';
import { useCarrotQuestInit } from './hooks';

export const CarrotQuestManager: React.FC = () => {
  const user = useAuth();
  const { data: fund } = useGetFundFromOrigin();

  const isInitialized = useCarrotQuestInit(fund?.cq_api_key);

  // Контакты дописываются в профиль только после того, как он перестал быть
  // анонимным, и только из ответа API. Раньше это делал обработчик сабмита
  // формы регистрации — до валидации, до согласия на обработку персональных
  // данных и до ответа сервера (AI-104).
  React.useEffect(() => {
    if (!isInitialized || !user) {
      return;
    }

    if (carrotQuestAuth(user, user.user_carrot_quest_hash)) {
      carrotQuestIdentifyUser(user);
    }
  }, [isInitialized, user]);

  // Маркетинговый трекинг раньше приезжал строкой из админки CarrotQuest и
  // исполнялся вендором через eval; под CSP он заблокирован, поэтому живёт
  // здесь (AI-102). Подписываемся только после инициализации виджета —
  // до неё нет очереди, в которую можно складывать вызовы.
  React.useEffect(() => {
    if (!isInitialized) {
      return;
    }

    const stopTracking = setUpTrackingEvents();
    const stopGoals = setUpMetricaGoals();

    return () => {
      stopTracking();
      stopGoals();
    };
  }, [isInitialized]);

  return '';
};
